import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./shared/styles/tokens.css";
import "./shared/styles/base.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Booply web root element was not found.");
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
